module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.audioSource) ? _c('audio-player', {
    attrs: {
      "sources": [_vm.audioSource],
      "preload": false,
      "playingEpisode": _vm.playingEpisode,
      "html5": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bafa054"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PlayerContainer.vue
// module id = 772
// module chunks = 1